import {
  DataVersion,
  LocationAlarmUpdateRequestDTO,
  UnifiedMonitoringProduct,
} from '@hakimo-ui/hakimo/types';
import { useHttpClient, withDataVersion } from '@hakimo-ui/hakimo/util';

export function useResolveLocationAlarm() {
  const httpClient = useHttpClient();

  return (
    alarmId: string,
    product: UnifiedMonitoringProduct,
    data: LocationAlarmUpdateRequestDTO,
    tap?: (response: Response) => void,
    dataVersion?: DataVersion
  ) => {
    const url = `/v2/orm/location_alarms/update/${alarmId}?product=${product}`;

    const request = new Request(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    withDataVersion(request, dataVersion);

    return httpClient(request, {
      tap,
    });
  };
}

export default useResolveLocationAlarm;
